<template>
  <el-dropdown-menu v-bind="$attrs"><slot /></el-dropdown-menu>
</template>
<script>
export default {
  name: 'RtDropdownMenu',
  data() {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// rtDropdownMenu.vue?382a273c